import script from "./DisplayChangeControl.vue?vue&type=script&setup=true&lang=js"
export * from "./DisplayChangeControl.vue?vue&type=script&setup=true&lang=js"

import "./DisplayChangeControl.vue?vue&type=style&index=0&id=563494e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-563494e1"]])

export default __exports__